import { css, genDynamicVariant } from '@backyard-ui/styles';

const styles = css({
  position: 'relative',
  display: 'block',
  textDecoration: 'none',
  background: '$white',
  WebkitTapHighlightColor: 'transparent',
  variants: {
    padding: {
      xs: {
        padding: '$2',
      },
      sm: {
        padding: '$3',
      },
      md: {
        padding: '$4',
      },
      lg: {
        padding: '$4 $6',
      },
      xl: {
        padding: '$6 $8',
      },
    },
    radius: genDynamicVariant('radii', (value) => ({
      borderRadius: value,
    })),
    shadow: genDynamicVariant('shadows', (value) => ({
      boxShadow: value,
    })),
  },
  defaultVariants: {
    padding: 'lg',
    radius: 'sm',
    shadow: 'xs',
  },
});

export default styles;
